export enum ResourceOccupationStatusEnum {
  Occupied = 'Occupied',
  Unoccupied = 'Unoccupied',
  Unknown = 'Unknown',
  Default = 'Default',
}
